import React from 'react'
import { useSelector } from 'react-redux'
import { Redirect } from 'react-router'
import { Switch, Route, useRouteMatch } from 'react-router-dom'

import { EuiPage, EuiPageBody } from '@elastic/eui'

import config from 'app/config'
import { RootState } from 'app/rootReducer'
import { AcTernary } from 'components/Routing/AcTernary'
import CampaignInsightsPage from 'features/campaigns/campaign/insights/CampaignInsightsPage'

import { WhiteLabel } from '../../api/interfaces'
import { useWhiteLabel } from '../../whiteLabel/WhiteLabelContext'
import StartCreateAdPage from './StartCreateAdPage'
import EditAdPage from './ad/EditAdPage'
import { AgencyV2EditCampaignPage } from './campaign/AgencyV2EditCampaignPage/AgencyV2EditCampaignPage'
import EditCampaignPage from './campaign/EditCampaignPage'
import { AgencyV2ListCampaignsPage } from './campaigns/AgencyV2ListCampaignsPage'
import ListCampaignsPage from './campaigns/ListCampaignsPage'
import { AgencyV2CreateAdAudioPage } from './createAd/audio/agencyV2/AgencyV2CreateAdAudioPage'
import { AgencyV2CreateAdBillboardsRetailPage } from './createAd/billboards/agencyV2/AgencyV2CreateAdBillboardsRetailPage'
import CreateAdBillboardsRetailPage from './createAd/billboards/retail/Page'
import { AgencyV2InternetAdCreate } from './createAd/internet/agencyV2/AgencyV2InternetAdCreate'
import CreateAdInternetRetailPage from './createAd/internet/retail/Page'
import { AgencyV2CreateAdTvRetailPage } from './createAd/tv/agenvyV2/AgencyV2CreateAdTvRetailPage'
import CreateAdTvRetailPage from './createAd/tv/retail/Page'

const CampaignsPage = () => {
  const { path } = useRouteMatch()
  const campaign = useSelector((state: RootState) => state.campaign)
  const whiteLabel = useWhiteLabel()

  const whiteLabelType = whiteLabel?.getWhiteLabel()

  return (
    <EuiPage className='euiPage--platform'>
      <EuiPageBody>
        <Switch>
          <Route exact path={path}>
            {whiteLabelType === WhiteLabel.AgencyV2 ? <AgencyV2ListCampaignsPage /> : <ListCampaignsPage />}
          </Route>
          <Route path={`${path}/insights/:campaignId`}>
            <CampaignInsightsPage />
          </Route>
          <Route path={`${path}/edit/:campaignId`}>{whiteLabelType !== WhiteLabel.AgencyV2 ? <EditCampaignPage /> : <AgencyV2EditCampaignPage />}</Route>
          <Route path={`${path}/createAd/:campaignId`}>
            <StartCreateAdPage />
          </Route>
          <Route path={`${path}/ads/:campaignId/edit/:adId`}>
            <EditAdPage />
          </Route>
          <Route exact path={`${path}/internet/public/:step`}>
            <AcTernary hasRequiredSetup={() => !!campaign.campaign?.id} failRender={() => <Redirect to={`/campaigns`} />} succeedRender={() => (whiteLabel?.getWhiteLabel() === WhiteLabel.AgencyV2 ? <AgencyV2InternetAdCreate /> : <CreateAdInternetRetailPage />)} />
          </Route>
          <Route exact path={`${path}/billboards/public/:step`}>
            <AcTernary hasRequiredSetup={() => !!campaign.campaign?.id && (whiteLabel?.getWhiteLabel() === WhiteLabel.AgencyV2 || config.features.billboardSuggestionsEnabled)} failRender={() => <Redirect to={`/campaigns`} />} succeedRender={() => (whiteLabel?.getWhiteLabel() === WhiteLabel.AgencyV2 ? <AgencyV2CreateAdBillboardsRetailPage /> : <CreateAdBillboardsRetailPage />)} />
          </Route>
          <Route exact path={`${path}/tv/public/:step`}>
            <AcTernary hasRequiredSetup={() => !!campaign.campaign?.id} failRender={() => <Redirect to={`/campaigns`} />} succeedRender={() => (whiteLabel?.getWhiteLabel() === WhiteLabel.AgencyV2 ? <AgencyV2CreateAdTvRetailPage /> : <CreateAdTvRetailPage />)} />
          </Route>
          <Route exact path={`${path}/audio/public/:step`}>
            <AcTernary hasRequiredSetup={() => !!campaign.campaign?.id && whiteLabel?.getWhiteLabel() === WhiteLabel.AgencyV2} failRender={() => <Redirect to={`/campaigns`} />} succeedRender={() => <AgencyV2CreateAdAudioPage />} />
          </Route>
        </Switch>
      </EuiPageBody>
    </EuiPage>
  )
}

export default CampaignsPage
